module.exports = __webpack_public_path__ + "static/media/kuvikweb.f22d1d9e.jpg";